import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../../request.state.interface";
import wheelOfFortuneGetInfoHandler from "./get-info.handler";
import { TicketType } from "../../../components/TicketsPanel/Ticket";
import wheelOfFortuneSpinHandler from "./spin.handler";

export interface IWheelOfFortunePrize {
    sectorIndex: number;
    prizeType: TicketType | 'balance';
    prizeValue: number;
}

export enum WheelOfFortuneMode {
    Free = 1,
    Advanced = 2,
    Premium = 3,
}

export type WheelOfFortunePrizesByMode = Partial<Record<WheelOfFortuneMode, IWheelOfFortunePrize[]>>;

export interface IWheelOfFortuneGameState extends IRequestState {
    mode: WheelOfFortuneMode;
    freeSpinsCount: number;
    nextResetTime: number;
    wheel: WheelOfFortunePrizesByMode | null;
    costs: Record<number, number> | null;
};

const initialState: IWheelOfFortuneGameState = {
    mode: WheelOfFortuneMode.Free,
    freeSpinsCount: 0,
    nextResetTime: 0,
    costs: null,
    wheel: null,

    loading: false,
    error: "",
};

const wheelOfFortuneSlice = createSlice({
    name: 'game/wheel-of-fortune',
    initialState,
    reducers: {
        wheelOfFortuneSetMode: (state, action: PayloadAction<WheelOfFortuneMode>) => {
            state.mode = action.payload;
        }
    },
    extraReducers: (builder: ActionReducerMapBuilder<IWheelOfFortuneGameState>) => {
        wheelOfFortuneGetInfoHandler(builder);
        wheelOfFortuneSpinHandler(builder);
    },
});

export default wheelOfFortuneSlice.reducer;
export const { wheelOfFortuneSetMode } = wheelOfFortuneSlice.actions;